import { APP_DOMAIN, BASE_URL } from "../constants/constants"

export const generateSimpleHash = (str) => {
  let hash = 0
  if (str.length === 0) return hash.toString()

  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash = hash & hash // Конвертируем в 32bit integer
  }

  // Возвращаем положительное число в виде строки
  return Math.abs(hash).toString(16)
}

// Генерируем реферальный код из адреса кошелька
export const generateReferralCode = (walletAddress) => {
  if (!walletAddress) return ""

  // Убираем '0x' и делаем хеш
  const cleanAddress = walletAddress.replace("0x", "").toLowerCase()
  return generateSimpleHash(cleanAddress)
}

// Генерируем полную реферальную ссылку
export const generateReferralLink = (walletAddress) => {
  const referralCode = generateReferralCode(walletAddress)
  return `${APP_DOMAIN}${BASE_URL}/ref?=${referralCode}`
}
